const hasAlloys = $("#js-hasAlloys");
const hasAlloysHidden = $("#js-hasAlloysHidden");
const quotedValueDisp = $("#js-quotedValueDisp");

if (hasAlloys.length) {
	var quotedValue, quotedValueWithComma;

	hasAlloys.on("change", function() {
		hasAlloysHidden.val($(this).is(':checked'));

		if (hasAlloysHidden.val() == "true") {
			quotedValue = $(this).attr("data-quoteChecked");

			console.log("Alloys checked: " + quotedValue);
		} else {
			quotedValue = $(this).attr("data-quoteUnChecked");

			console.log("Alloys not checked: " + quotedValue);
		}

		quotedValueWithComma = "£" + quotedValue.toLocaleString();
		if (quotedValueWithComma !== quotedValueDisp.text()) {
			quotedValueDisp.fadeOut('fast', function() {
				quotedValueDisp.text(quotedValueWithComma).fadeIn('slow');
			});
		};
	});

	hasAlloys.trigger("change");
}